import { Dialog, DialogTitle, DialogContent, DialogActions } from "@mui/material";
import { useForm } from "react-hook-form";
import { useCallback } from "react";
import { ModalLoading } from "../../../../../../common/components/modal_loading";
import DefaultFormInput from "../../../../../../common/components/default_form_input";
import FormContainer from "../../../../../../common/components/form_container";
import PrimaryButton from "../../../../../../common/components/primary_button";
import { ContratoFinanceiroForm } from "../../../schemas/ContratoFinanceiro_cadastro/ContratoFinanceiro_form";

/**
 * UpdateMotivoModal
 */
type Props = {
  open: boolean,
  saving: boolean,
  hookForm: ReturnType<typeof useForm<ContratoFinanceiroForm>>,

  onSubmit: () => void,
  onClose: () => void,
};

export const UpdateMotivoModal = ({
  open,
  saving,
  hookForm,
  onSubmit,
  onClose,

}: Props) => {


  const handleClose = useCallback(() => {
    if (!saving) onClose();
  }, [saving, onClose]);

  return (

    <Dialog
      open={open}
      slotProps={{
        paper: {
          component: 'form',
          onSubmit: onSubmit,
        }
      }}
      sx={{
        "& .MuiDialog-container": {
          "& .MuiPaper-root": {
            width: "100%",
            maxWidth: "45rem",
          },
        },
      }}>

      <DialogTitle>
        Alteração de Contrato - Motivo
      </DialogTitle>

      <DialogContent>
        <ModalLoading loading={saving}>
          <FormContainer title={"Informações"} arrangement="fullRow">
            <>
              <DefaultFormInput
                name='motivo'
                label='Motivo da alteração'
                readOnly={saving}
                required
                multiline={true}
                rows={8}
                reactHookForm={hookForm}
              />

            </>
          </FormContainer>
        </ModalLoading>
      </DialogContent>

      <DialogActions>
        <div className="w-full h-full items-center justify-end flex px-4 pb-4 gap-4">

          <div className="flex flex-row gap-2">
            <div className="p-2 hover:bg-hover-light-gray cursor-pointer dark:hover:bg-border-dark-gray rounded-[4px] font-semibold">
              <h1
                className="text-sm text-black dark:text-white"
                onClick={handleClose}>
                Cancelar
              </h1>
            </div>

            <div className="w-[120px]">
              {saving ? (
                <PrimaryButton
                  buttonColor="primary-green">
                  Salvando...
                </PrimaryButton>
              ) : (
                <PrimaryButton
                  type="submit"
                  buttonColor="primary-green">
                  Salvar
                </PrimaryButton>
              )}
            </div>
          </div>
        </div>
      </DialogActions>
    </Dialog>
  );
}